import { useCallback, useMemo } from 'react';
import { FormFieldsData, useInputHelper } from 'framework/form';
import FocusTimeDayTimeline, { FocusTimeDayTimelineSlot } from './FocusTimeDayTimeline';

type FormFocusTimeDayTimelineProps = Readonly<{
  currentMinutes: number | null;
  slots?: FocusTimeDayTimelineSlot[];
  source: string;
}>;

const EMPTY_SLOTS: FocusTimeDayTimelineSlot[] = [];

const FormFocusTimeDayTimeline = ({ currentMinutes, slots = EMPTY_SLOTS, source }: FormFocusTimeDayTimelineProps) => {
  const { getValue, getRawOnChangeCallback } = useInputHelper<FocusTimeDayTimelineSlot[]>({ source });
  const formValue = getValue();
  const formSlots = useMemo(() => (Array.isArray(formValue) ? formValue : slots), [formValue, slots]);
  const formOnChange = getRawOnChangeCallback();

  const handleChange = useCallback(
    (nextSlots: FocusTimeDayTimelineSlot[]) => {
      formOnChange?.({ [source]: nextSlots } as FormFieldsData);
    },
    [formOnChange, source],
  );

  return <FocusTimeDayTimeline currentMinutes={currentMinutes} slots={formSlots} onChange={handleChange} />;
};

export default FormFocusTimeDayTimeline;
